import {ImageSourcePropType} from "react-native/Libraries/Image/Image";


export interface Emoji {
    name: string,
    icon: ImageSourcePropType
}

export const emojiArr = [
    "😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣", "😊", "😇",
    "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘", "😗", "😙", "😚",
    "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔",
    "🤐", "😐", "😑", "😶", "😏", "🙄", "😒", "😞", "😔", "😟",
    "😕", "🙁", "☹️", "😣", "😖", "😫", "😩", "🥺", "😢", "😭",
    "😤", "😠", "😡", "🤬", "🤯", "😳", "🥵", "🥶", "😱", "😨",
    "😰", "😥", "😓", "🤤", "😪", "😴", "😷", "🤒", "🤕", "🤢",
    "🤮", "🤧", "🥳", "🤠", "😎", "🤓", "🧐", "😬", "😯", "😲",
    "😮", "🥱", "😵", "🥴",
    
    // 💬 手勢
    "👋", "🤚", "🖐️", "✋", "🖖", "👌", "🤌", "🤏", "✌️", "🤞",
    "🤟", "🤘", "🤙", "👈", "👉", "👆", "🖕", "👇", "☝️", "👍",
    "👎", "✊", "👊", "🤛", "🤜", "👏", "🙌", "👐", "🤲",

    // ❤️ 心情與情感
    "💋", "💌", "💘", "💝", "💖", "💗", "💓", "💞", "💕", "💟",
    "❣️", "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",

    // 🐶 動物
    "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯",
    "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒",

    // 🍎 食物
    "🍏", "🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐",
    "🥝", "🍍", "🥭", "🍑", "🍒", "🥥", "🥦", "🥬", "🥕", "🌽",
    "🌶️", "🧄", "🧅",

    // 🏀 活動
    "⚽", "🏀", "🏈", "⚾", "🎾", "🏐", "🏉", "🥏", "🎱", "🏓",
    "🏸", "🥅", "🏒", "🏑", "🥍", "🏏", "🪃",

    // ✈️ 交通
    "🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐",
    "🚚", "🚛", "🚜", "🛺", "🚲", "🛵", "🏍️", "🚨",

    // 🔥 常用符號
    "💯", "🔞", "💢", "💥", "💫", "💦", "💨", "🕳️", "🔥", "🌈",
    "☀️", "⛅", "🌧️", "❄️", "🌪️", "🌊", "🎃", "🎄", "🎉", "🎁",
    "🎈", "🔔", "🔕"
];



/*

const rules = {
    emoji: new RegExp(
        `^(${emojiMapping
            .map((emoji) => emoji.name.replace(/(\[|\])/g, "\\$1"))
            .join("|")})`
    ),
    text: /^([\s\S]+?)\[.{2,3}\]/
};

export function spliceTextEmoji(text: string) {

    let src = text;
    let cap: string[] | null;
    const result: { type: "text" | "emoji"; content?: string, icon?: ImageSourcePropType }[] = [];

    while (src) {
        if ((cap = rules.emoji.exec(src))) {
            src = src.substring(cap[0].length);
            result.push({
                type: "emoji",
                icon: emojiMapping.find(value => {
                    return value.name === cap?.[0]
                })?.icon
            });
            continue;
        }

        if ((cap = rules.text.exec(src))) {
            src = src.substring(cap[1].length);
            result.push({
                type: "text",
                content: cap[1]
            });

            continue;
        }

        result.push({
            type: "text",
            content: src
        });

        src = "";
    }

    return result;
}

export function endsWithAny(str: string): number {
    if (str.endsWith("]")) {
        const index1 = str.lastIndexOf("[");
        const index2 = str.lastIndexOf("]");
        if (index1 !== -1 && index2 !== -1) {
            const emoji = str.slice(index1, index2 + 1);
            for (let i = 0; i < emojiMapping.length; i++) {
                const row = emojiMapping[i];
                if (row.name === emoji) {
                    return emoji.length;
                }
            }
        }
    }
    return 1;
}*/
